<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center z-50 no-scrollbar">
    <div class="flex flex-col w-full gap-4 p-4 bg-white rounded shadow-lg max-w-3xl relative">

        <div class="flex flex-row justify-between items-center border-b pb-3 mb-2">
            <div class="flex flex-row items-center gap-3">
                @if (viewableUser?.photoURL) {
                    <img [src]="viewableUser?.photoURL" class="w-12 h-12 rounded-full object-cover shadow" />
                } @else {
                    <div class="w-12 h-12 rounded-full bg-primary-100 text-primary-500 font-bold flex items-center justify-center text-lg uppercase shadow">
                        {{ (viewableUser?.name || '') | initials }}
                    </div>
                }
                <div class="flex flex-col gap-0.5 justify-start">
                    <h1 class="font-bold text-xl text-blueGray-800">{{title}}</h1>
                    <p class="text-primary-300 text-xs font-semibold">{{description}}</p>
                </div>
            </div>
            <btn-icon icon="fa fa-close" (click)="onCancel()"
                class="text-primary-300 hover:text-primary-300"></btn-icon>
        </div>

        <div class="flex flex-wrap w-full">
            <div class="relative w-full flex flex-col gap-4">

                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Name
                    </label>
                    <span class="text-blueGray-600 capitalize text-sm">{{ viewableUser?.name }}</span>
                </div>

                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Profession
                    </label>
                    <span class="text-blueGray-600 capitalize text-sm">{{ viewableUser?.profession }}</span>
                </div>

                @if (canViewDob) {
                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Date Of Birth
                    </label>
                    @if (viewableUser?.dob) {
                    <span class="text-blueGray-600 text-sm">{{
                        viewableUser!.dob | moment:
                        'DD MMM YYYY' }}</span>
                    } @else {
                    <span class="text-blueGray-600 capitalize text-sm">Unspecified</span>
                    }
                </div>
                }

                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Primary Contact
                    </label>
                    <span class="text-blueGray-600 text-sm">
                        {{ viewableUser?.contact?.phoneCode != null ? '+' + viewableUser?.contact?.phoneCode : ''
                        }}</span>
                    <span class="text-blueGray-600 text-sm">
                        {{ viewableUser?.contact?.contact != null ? viewableUser?.contact?.contact : "Not Available"
                        }}</span>
                </div>

                <div class="w-full">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold">
                        Email
                    </label>
                    <span class="text-blueGray-600 text-sm">{{ viewableUser?.email }}</span>
                </div>

                <div class="w-full">
                    <div class="w-full">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Address
                        </label>
                        <span class="text-blueGray-600 normal-case text-sm">{{ viewableUser?.address?.buildingNo }}
                            {{ viewableUser?.address?.buildingName }}</span>
                        <span class="text-blueGray-600 normal-case text-sm block">{{ viewableUser?.address?.addressLine1 }}
                            {{ viewableUser?.address?.addressLine2 }}</span>
                        <span class="text-blueGray-600 normal-case text-sm block">
                            {{ viewableUser?.address?.city }} {{ viewableUser?.address?.country }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>